import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContenedorBoton, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import styled from 'styled-components';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cargar_Cheques, cargar_ChequesSinAplicar, inicializar_Cheques } from '../../actions/clientes/act_cli03';
import { validarFechaMomentEnFormatoString, validarJSON, validarPermisoAcceso } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_String, formatearNumeroDecimal } from '../../funciones_globales/format';
import global_axios from '../../funciones_globales/interaccionapi';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { obtenerSecuencial } from '../../funciones_globales/parametros';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
import { cargar_PlanillasDepositoCheque, inicializar_PlanillasDepositoCheque } from '../../actions/bancos/act_banc05';

const ContenedorChequesSinAplicar = styled.div`
  margin-top: 20px;
  height: 400px;
  width: 770px;
`;

const Contenedor = styled.div`
  display: ${props => props.isVisible?'block':'none'};
`;

const ContenedorToggle = styled.span`
  margin-left: 15px;
`;

const ContenedorCentrado = styled.div`
  width: 80%;
  margin:0 auto;
`;

class FormCli11 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {
      cheques: [],
      chequesSinAplicar: [],
      fechaVctoChequeDesde: null,
      fechaVctoChequeHasta: null,
      fechaReciboDesde: null,
      fechaReciboHasta: null,
      fechaVencChequeHasta: null,
      totalCheques: 0,
      isVisibleNuevaPlanilla: true,      
      fechaPlanillaDesde: null,
      fechaPlanillaHasta: null,
      operacion: 'C',

      columnsDefGridCheques: [
        { header: "No.",
          field: "Secuencia",
          width: 30,
          type: "string",
          suppressFilter: true
        },
        { header: "F. Cheque",
          field: "FechaCheque",
          width: 85,
          type: "string"
        },
        { header: "F. Vcto.",
          field: "FechaVcto",
          width: 85,
          type: "string"
        },
        { header: "F. Ingreso",
          field: "Fecha",
          width: 85,
          type: "string"
        },
        { header: "Banco",
          field: "Banco",
          width: 135,
          type: "string"
        },
        { header: "Cuenta",
          field: "Cuenta",
          width: 95,
          type: "string"
        },
        { header: "No. Cheque",
          field: "Cheque",
          width: 85,
          type: "string"
        },
        { header: "Cliente",
          field: "Cliente",
          width: 210,
          type: "string"
        },        
        { header: "Estado",
          field: "Estado",
          width: 70,
          type: "string"
        },            
        { header: "Caja",
          field: "Caja",
          width: 70,
          type: "string",
          suppressFilter: true
        },
        { header: "Mov. Caja",
          field: "Movimiento",
          width: 90,
          type: "string"
        },
        { header: "Valor",
          field: "Valor",
          width: 90,
          type: "num_decimal",
          filter: "number"
        }
      ],
      columnsDefGridChequesSinAplicar: [
        { header: "",
          width: 30,
          checkboxSelection: true,
          suppressSorting: true,
          suppressMenu: true,
          suppressFilter: true,
          pinned: true,
          headerCheckboxSelection: true,  
          headerCheckboxSelectionFilteredOnly: true
        }, 
        { header: "No.",
          field: "Secuencia",
          width: 40,
          type: "string",
          suppressFilter: true,
        },
        {
          header: "F. Vcto.",
          field: "FechaVcto",
          width: 95,
          type: "string"
        },
        { header: "Fecha Cobro",
          field: "FechaCobro",
          width: 95,
          type: "string"
        },
        { header: "Banco",
          field: "Banco",
          width: 140,
          type: "string"
        },
        { header: "Cuenta",
          field: "Cuenta",
          width: 90,
          type: "string"
        },
        { header: "No. Cheque",
          field: "Cheque",
          width: 75,
          type: "string"
        },
        { header: "Cliente",
          field: "Cliente",
          width: 200,
          type: "string"
        },            
        { header: "Forma Pago",
          field: "FormaPago",
          width: 60,
          type: "string"
        },        
        { header: "Valor",
          field: "Valor",
          width: 80,
          type: "num_decimal",
          filter: "number"
        }
      ],
      isVisibleModalChequesSinAplicar: false,
      columnsDefGridPlanillasDep:[
        { header: "No. Planilla",
          field: "IdPlanillaDepChq",
          width: 86,
          type: "num_entero"
        },
        { header: "Fecha Desde",
          field: "FechaDesde",
          width: 95,
          type: "string"
        },
        { header: "Fecha Hasta",
          field: "FechaHasta",
          width: 95,
          type: "string"
        },
        { header: "No. Cheques",
          field: "NroCheques",
          width: 90,
          type: "num_entero"
        },
        { header: "Total",
          field: "Total",
          width: 100,
          type: "num_decimal"
        }
      ]
    };
    this.gridChequesOptions = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      suppressRowClickSelection: true,
      getRowStyle: (params) =>{
        if (params.data.Procedencia === 'I') {
          return {'background-color': '#FAFAD2'}
        }
        return null;
      }
    };
    this.gridChequesSinAplicarOptions = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: 'multiple'
    };
    this.gridPlanillasDepositoOptions = {
      enableColResize: true,
      enableSorting: true,
      rowSelection: 'single'
    };
    this.onGridChequesReady = this.onGridChequesReady.bind(this);
    this.onGridChequesSinAplicarReady = this.onGridChequesSinAplicarReady.bind(this);
    this.onGridPlanillasDepositoReady = this.onGridPlanillasDepositoReady.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.cargarCheques = this.cargarCheques.bind(this);
    this.cargarChequesSinAplicar = this.cargarChequesSinAplicar.bind(this);
    this.generarPlanillaDeposito = this.generarPlanillaDeposito.bind(this);
    this.importarChequesSeleccionados = this.importarChequesSeleccionados.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.limpiarModalChequesSinAplicar = this.limpiarModalChequesSinAplicar.bind(this);
    this.buscarPlanillasDeposito = this.buscarPlanillasDeposito.bind(this);
    this.anularPlanillaDeposito = this.anularPlanillaDeposito.bind(this);
    this.imprimirPlanillaDeposito = this.imprimirPlanillaDeposito.bind(this);
    this.limpiarConsultaPlanillasDeposito = this.limpiarConsultaPlanillasDeposito.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });    
  }

  onGridChequesReady(params) {
    this.apiGridCheques = params.api;
    this.columnApiGridCheques = params.columnApi;
  }

  onGridChequesSinAplicarReady(params) {
    this.apiGridChequesSinAplicar = params.api;
    this.columnApiGridChequesSinAplicar = params.columnApi;
  }
  
  onGridPlanillasDepositoReady(params) {
    this.apiGridPlanDeposito = params.api;
    this.columnApiPlanDeposito = params.columnApi;
  }

  componentDidMount(){
    this.props.generar_LogAuditoriaIngresoForm('0111');
    this.props.inicializar_Cheques();
    this.props.inicializar_PlanillasDepositoCheque();
    obtenerSecuencial('PlanillaDepCheque')
    .then(secPlanilla=>{
      this.setState({ultSecuencial: secPlanilla.codigo - 1})
    });
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0111');
  }

  limpiar(){    
    this.setState({
      cheques: [],
      fechaVctoChequeDesde: null,
      fechaVctoChequeHasta: null,
      fechaReciboDesde: null,
      fechaReciboHasta: null,
      fechaVencChequeHasta: null,
      isVisibleModalChequesSinAplicar: false,
      chequesSinAplicar: [],
      totalCheques: 0
    });
    this.props.inicializar_Cheques();
  }

  limpiarModalChequesSinAplicar(){
    this.setState({
      fechaReciboDesde: null,
      fechaReciboHasta: null,
      fechaVencChequeHasta: null,
      chequesSinAplicar: []
    });
  }

  limpiarConsultaPlanillasDeposito(){
    this.setState({
      fechaPlanillaDesde: null,
      fechaPlanillaHasta: null
    });
    this.props.inicializar_PlanillasDepositoCheque();
  }

  cargarCheques(){    
    let fechaVctoChequeDesde = formatearFechaMoment_a_String(this.state.fechaVctoChequeDesde);
    let fechaVctoChequeHasta = formatearFechaMoment_a_String(this.state.fechaVctoChequeHasta);

    if (!validarFechaMomentEnFormatoString(fechaVctoChequeDesde)){
      alert('El campo Fecha Vencimiento Desde es inválido.');
      return;
    }

    if (!validarFechaMomentEnFormatoString(fechaVctoChequeHasta)){
      alert('El campo Fecha Vencimiento Hasta es inválido.');
      return;
    }

    if(this.state.fechaVctoChequeHasta.diff(this.state.fechaVctoChequeDesde, 'days')<0){
      alert('La Fecha Vencimiento Desde no puede ser mayor que Fecha Vencimiento Hasta.');
      return;
    }
    this.props.inicializar_Cheques();
    this.props.cargar_Cheques('P', fechaVctoChequeDesde, fechaVctoChequeHasta)
    .then(()=>{
      try {
        let cheques = [];
        let totalCheques = 0;    
    
        this.props.cheques.forEach((item, i)=>{
          cheques.push({
            Secuencia: (i+1),
            FechaCheque: item.FechaCheque,
            FechaVcto: item.Vencimiento,
            Fecha: item.Fecha,
            Banco: validarJSON(item.banco)?`${item.banco.Codigo} - ${item.banco.Descripcion}`:'',
            Cuenta: item.Cuenta,
            Cheque: item.Cheque,
            Cliente: validarJSON(item.cli)?`${item.cli.Codigo} - ${item.cli.Nombre}`:'',
            Estado: item.Status,          
            Caja: item.Caja,
            Movimiento: item.Movimiento,
            Valor: item.Valor,
            Procedencia: 'C'
          });
          totalCheques += parseFloat(item.Valor===null?0:item.Valor);
        });

        this.setState({cheques, totalCheques});        
      } catch (error) {
        alert(`Ocurrió un error al cargar los cheques. Error: ${error}`);
      }
    });
  }

  cargarChequesSinAplicar(){
    let fechaReciboDesde = formatearFechaMoment_a_String(this.state.fechaReciboDesde);
    let fechaReciboHasta = formatearFechaMoment_a_String(this.state.fechaReciboHasta);    
    let fechaVencChequeHasta = formatearFechaMoment_a_String(this.state.fechaVencChequeHasta);

    if (!validarFechaMomentEnFormatoString(fechaReciboDesde)){
      alert('El campo Fecha Recibo Desde es inválido.');
      return;
    }

    if (!validarFechaMomentEnFormatoString(fechaReciboHasta)){
      alert('El campo Fecha Recibo Hasta es inválido.');
      return;
    }
    
    if (!validarFechaMomentEnFormatoString(fechaVencChequeHasta)){
      alert('El campo Fecha Vencimiento Cheque Hasta es inválido.');
      return;
    }

    if(this.state.fechaReciboHasta.diff(this.state.fechaReciboDesde, 'days')<0){
      alert('La fecha Fecha Recibo Desde no puede ser mayor que Fecha Recibo Hasta.');
      return;
    }

    this.props.cargar_ChequesSinAplicar(fechaReciboDesde, fechaReciboHasta, fechaVencChequeHasta)
    .then(()=>{
      let chequesSinAplicar = [];
      this.props.cheques.forEach((item, i)=>{
        chequesSinAplicar.push({
          Secuencia: (i+1),
          FechaVcto: item.FechaVencCheque,
          FechaCobro: item.FechaCobro,
          Banco: item.Banco,
          Cuenta: item.Cuenta,
          Cheque: item.Cheque,
          Cliente: item.Cliente,
          FormaPago: item.FormaPago,
          Valor: item.Valor
        })
      })
      this.setState({chequesSinAplicar});
    });
  }

  importarChequesSeleccionados(){
    if (this.state.chequesSinAplicar.length===0){
      alert('No existen cheques sin aplicar que se puedan seleccionar.');
      return;
    }
    let chequesSinAplicarSel = this.apiGridChequesSinAplicar.getSelectedRows();
      
    if (chequesSinAplicarSel.length === 0){
      alert('No ha seleccionado los cheques sin aplicar que va a importar.');
      return;
    }
    let cheques = [...this.state.cheques];
    let totalCheques = parseFloat(this.state.totalCheques);

    try {
      chequesSinAplicarSel.forEach(item=>{     
        if (!this.existeChequeEnLista(item.Cliente.substr(0, 7), item.Banco.substr(0, 2), item.Cuenta, item.Cheque, 'I')){
          cheques.push({
            Secuencia: cheques.length+1,
            FechaCheque: null,
            FechaVcto: item.FechaVcto,
            Fecha: item.FechaCobro,
            Banco: item.Banco,
            Cuenta: item.Cuenta,
            Cheque: item.Cheque,
            Cliente: item.Cliente,
            Estado: null,        
            Caja: null,
            Movimiento: null,
            Valor: item.Valor,
            Procedencia: 'I'
          });
          totalCheques += parseFloat(item.Valor);
        }
      });
      this.setState({cheques, isVisibleModalChequesSinAplicar: false, totalCheques});      
    } catch (error) {
      alert(`Ocurrió un error al importar los cheques sin aplicar. Error: ${error}`);
    }    
  }

  existeChequeEnLista(cliente, banco, cuenta, nrocheque, procedencia){
    let existeCheque = false;
    for(let i=0; i<this.state.cheques.length; i++){
      let cheque = this.state.cheques[i];

      if (cheque.Cliente.substr(0, 7) === cliente.trim() &&
          cheque.Banco.substr(0, 2) === banco.trim() &&
          cheque.Cuenta.trim() === cuenta.trim() &&
          cheque.Cheque.trim() === nrocheque.trim() &&
          cheque.Procedencia === procedencia){
          existeCheque = true;
          break;
        }
    }

    return existeCheque;
  }

  generarPlanillaDeposito(){
    if (this.state.cheques.length ===0){
      alert('No existen cheques para el periodo de tiempo especificado.');
      return;
    }

    let fechaVctoChequeDesde = formatearFechaMoment_a_String(this.state.fechaVctoChequeDesde);
    let fechaVctoChequeHasta = formatearFechaMoment_a_String(this.state.fechaVctoChequeHasta);

    if (!validarFechaMomentEnFormatoString(fechaVctoChequeDesde)){
      alert('El campo Fecha Vencimiento Desde es inválido.');
      return;
    }

    if (!validarFechaMomentEnFormatoString(fechaVctoChequeHasta)){
      alert('El campo Fecha Vencimiento Hasta es inválido.');
      return;
    }

    let planillaDepositoCheque = {
      fechaVctoChequeDesde,
	    fechaVctoChequeHasta,
      usuario: getItemDatosSesion('usuario'),   
      idSesion: this.props.idRegAudit,
      cheques: []
    }

    this.state.cheques.forEach(item=>{
      planillaDepositoCheque.cheques.push({
        codCliente: item.Cliente.toString().slice(0,7),
        codBanco: item.Banco.toString().slice(0,2),
        cuenta: item.Cuenta,
        cheque: item.Cheque,
        valor: item.Valor,
        fechaVctoCheque: item.FechaVcto,
        procedencia: item.Procedencia
      });
    });

    this.props.cambiar_VisualizacionLoading(true);
    global_axios({
      method: 'POST',
      url: '/planillasdepositocheque',
      data: planillaDepositoCheque
    })
    .then((response)=>{
      let nroPlanilla = response.data.nroPlanilla;
      alert('La planilla de depósito se generó exitosamente. Planilla No.: ' + nroPlanilla);
      this.props.cambiar_VisualizacionLoading(false);
      this.limpiar();

      visualizarReporteEnPdf('&rpt=9&param1=' + nroPlanilla);
    })
    .catch((error)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  buscarPlanillasDeposito(){
    let fechaDesde = formatearFechaMoment_a_String(this.state.fechaPlanillaDesde);
    let fechaHasta = formatearFechaMoment_a_String(this.state.fechaPlanillaHasta);

    if (!validarFechaMomentEnFormatoString(fechaDesde)){
      alert('El campo Fecha Desde es inválido.');
      return;
    }

    if (!validarFechaMomentEnFormatoString(fechaHasta)){
      alert('El campo Fecha Hasta es inválido.');
      return;
    }
    
    if(this.state.fechaPlanillaHasta.diff(this.state.fechaPlanillaDesde, 'days')<0){
      alert('La Fecha Desde no puede ser mayor que Fecha Hasta.');
      return;
    }

    this.props.cargar_PlanillasDepositoCheque(fechaDesde, fechaHasta);
  }

  anularPlanillaDeposito(){
    if(this.props.planillasDepCheque.length===0 || this.apiGridPlanDeposito.getSelectedRows().length===0){
      alert('No ha seleccionado la Planilla de Depósito que va a anular.');
      return;
    }
   
    let idPlanilla = this.apiGridPlanDeposito.getSelectedRows()[0].IdPlanillaDepChq;

    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }

    let continuarAnul = window.confirm(`¿Está seguro de anular la Planilla de Depósito No.: ${idPlanilla}?`);
  
    if (!continuarAnul){
      return;
    }

    this.props.cambiar_VisualizacionLoading(true);
    
    global_axios({
      method: 'DELETE',
      url: `/planillasdepositocheque/${idPlanilla}`,
      headers: {'idregaudit': this.props.idRegAudit}
    })
    .then(()=> {
      this.props.cambiar_VisualizacionLoading(false);
      this.buscarPlanillasDeposito();
      alert('La Planilla de Depósito fue anulada correctamente.');      
    })
    .catch((error)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  imprimirPlanillaDeposito(){
    if(this.props.planillasDepCheque.length===0 || this.apiGridPlanDeposito.getSelectedRows().length===0){
      alert('No ha seleccionado la Planilla de Depósito que va a imprimir.');
      return;
    }
    
    let nroPlanilla = this.apiGridPlanDeposito.getSelectedRows()[0].IdPlanillaDepChq;    
    visualizarReporteEnPdf(`&rpt=9&param1=${nroPlanilla}`);
  }
  
  render(){
    return(
      <div>
        <ContenedorForm porc_ancho={this.state.isVisibleNuevaPlanilla?85:45}>
          <HeaderForm>
            <TituloForm>{this.state.isVisibleNuevaPlanilla?'Nueva Planilla de Depósito de Cheques':'Consulta de Planillas de Depósito de Cheques'}</TituloForm>
            <ContenedorToggle>
              <ToggleSwitch
                checked={this.state.isVisibleNuevaPlanilla}
                onChange={() => {this.setState({ isVisibleNuevaPlanilla: !this.state.isVisibleNuevaPlanilla, operacion: !this.state.isVisibleNuevaPlanilla?'C':'M'})}}
                size='sm'
              />
            </ContenedorToggle>
          </HeaderForm>
          <CuerpoForm>
            <Contenedor isVisible={this.state.isVisibleNuevaPlanilla}>           
              <Row>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Fecha Vcto. (Desde):</LabelForm>                
                  <PickerFecha fechaSeleccionada={this.state.fechaVctoChequeDesde} func_onChange={(fecha)=>{this.setState({fechaVctoChequeDesde: fecha})}}
                    func_onFocus={()=>{this.limpiar()}}/>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Fecha Vcto. (Hasta):</LabelForm>
                  <PickerFecha fechaSeleccionada={this.state.fechaVctoChequeHasta} func_onChange={(fecha)=> { this.setState({fechaVctoChequeHasta: fecha})}}/>
                </ContainerCol>
                <ContainerCol className='col-sm-1'>
                  <ContenedorBoton margen_arriba={20}>
                    <Tooltip placement="right" overlay='Buscar cheques'>
                      <button type='button' className='btn btn-success btn-sm' onClick={this.cargarCheques}><i className='fa fa-search'></i></button>
                    </Tooltip>
                  </ContenedorBoton>
                </ContainerCol>
                <ContainerCol className='col-sm-1'>
                  <ContenedorBoton margen_arriba={20}>                  
                    <button type='button' className='btn btn-default btn-sm' onClick={()=>{this.setState({isVisibleModalChequesSinAplicar:true})}}><i className='fa fa-download fa-lg'></i> Importar cheques sin aplicar</button>
                  </ContenedorBoton>
                </ContainerCol>
              </Row>            
              <Row>
                <ContainerCol className='col-sm-12'>
                  <AgGridRender altura='350px' data={this.state.cheques} columnas={this.state.columnsDefGridCheques}
                    gridOptions={this.gridChequesOptions} onGridReady={this.onGridChequesReady}/>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-offset-8 col-sm-2'>
                  <LabelForm>{`No. Reg.: ${this.state.cheques.length}`}</LabelForm>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                  <span className='pull-right'>
                    <LabelForm>{`Total: ${formatearNumeroDecimal(this.state.totalCheques)}`}</LabelForm>
                  </span>
                </ContainerCol>
              </Row>
              <Row margen_arriba={10}>
                <div className='col-sm-12'>
                  <div className='btn-group pull-right'>
                    <button type='button' className='btn btn-primary btn-sm' onClick={this.generarPlanillaDeposito}><i className='fa fa-university fa-lg'/> Generar Plan. Depósito</button>                    
                    <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                  </div>
                </div>
              </Row>
            </Contenedor>            
            <Contenedor isVisible={!this.state.isVisibleNuevaPlanilla}>
              <Row margen_arriba={10}>
                <ContainerCol className='col-sm-3'>
                  <LabelForm>Fecha Desde:</LabelForm>
                  <PickerFecha fechaSeleccionada={this.state.fechaPlanillaDesde} func_onChange={(fecha)=>{this.setState({fechaPlanillaDesde: fecha})}}/>
                </ContainerCol>
                <ContainerCol className='col-sm-3'>
                  <LabelForm>Fecha Hasta:</LabelForm>
                  <PickerFecha fechaSeleccionada={this.state.fechaPlanillaHasta} func_onChange={(fecha)=> { this.setState({fechaPlanillaHasta: fecha})}}/>
                </ContainerCol>
                <ContainerCol className='col-sm-1'>
                  <ContenedorBoton margen_arriba={20}>
                    <Tooltip placement='right' overlay='Buscar planillas'>
                      <button type='button' className='btn btn-success btn-sm' onClick={this.buscarPlanillasDeposito}><i className='fa fa-search'></i></button>
                    </Tooltip>
                  </ContenedorBoton>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-12'>
                  <ContenedorCentrado>
                    <AgGridRender altura='350px' data={this.props.planillasDepCheque} columnas={this.state.columnsDefGridPlanillasDep}
                      gridOptions={this.gridPlanillasDepositoOptions} onGridReady={this.onGridPlanillasDepositoReady}/>
                  </ContenedorCentrado>
                </ContainerCol>
              </Row>
              <Row margen_arriba={10}>
                <ContainerCol className='col-sm-12'>
                  <div className='btn-group pull-right'>
                    <button type='button' className='btn btn-info btn-sm' onClick={this.imprimirPlanillaDeposito}><i className='fa fa-print fa-lg'/> Imprimir</button>
                    <button type='button' className='btn btn-danger btn-sm' onClick={this.anularPlanillaDeposito}>
                      <i className="fa fa-ban fa-lg"></i> Anular</button>
                    <button type='button' className='btn btn-sm' onClick={this.limpiarConsultaPlanillasDeposito}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                  </div>
                </ContainerCol>
              </Row>
            </Contenedor>
          </CuerpoForm>
        </ContenedorForm>
        <ModalResponsive open={this.state.isVisibleModalChequesSinAplicar} onClose={()=>{this.setState({isVisibleModalChequesSinAplicar:false})}}>
          <ContenedorChequesSinAplicar>
            <Row>              
              <ContainerCol className='col-sm-3'>
                <LabelForm>Fecha Recibo (Desde):</LabelForm>
                <PickerFecha fechaSeleccionada={this.state.fechaReciboDesde} func_onChange={(fecha)=>{this.setState({fechaReciboDesde: fecha})}}
                  func_onFocus={()=>{this.limpiarModalChequesSinAplicar()}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-3'>
                <LabelForm>Fecha Recibo (Hasta):</LabelForm>
                <PickerFecha fechaSeleccionada={this.state.fechaReciboHasta} func_onChange={(fecha)=> { this.setState({fechaReciboHasta: fecha})}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-3'>
                <LabelForm>Fecha Vcto. Cheque (Hasta):</LabelForm>
                <PickerFecha fechaSeleccionada={this.state.fechaVencChequeHasta}
                  func_onChange={(fecha)=> { this.setState({fechaVencChequeHasta: fecha})}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-3'>
                <ContenedorBoton margen_arriba={20}>
                  <Tooltip placement='right' overlay='Buscar cheques sin aplicar'>
                    <button type='button' className='btn btn-success btn-sm' onClick={this.cargarChequesSinAplicar}><i className='fa fa-search'></i></button>
                  </Tooltip>
                </ContenedorBoton>
              </ContainerCol>
            </Row>
            <Row>
              <ContainerCol className='col-sm-12'>
                <AgGridRender altura='350px' data={this.state.chequesSinAplicar} columnas={this.state.columnsDefGridChequesSinAplicar}
                  gridOptions={this.gridChequesSinAplicarOptions} onGridReady={this.onGridChequesSinAplicarReady}/>
              </ContainerCol>
            </Row>
            <Row>
              <div className='col-sm-12'>
                <div className='btn-group pull-right'>
                  <button type='button' className='btn btn-primary btn-sm' onClick={this.importarChequesSeleccionados}><i className='fa fa-download fa-lg'/> Importar cheques seleccionados</button>              
                </div>
              </div>
            </Row>
          </ContenedorChequesSinAplicar>
        </ModalResponsive>
      </div>
    )
  }
}

const mapStateToProps = state =>{
  return {  permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            cheques: state.clientes.cheques,
            planillasDepCheque: state.bancos.planillasDepCheque
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cargar_Cheques, cargar_ChequesSinAplicar,
    inicializar_Cheques, cambiar_VisualizacionLoading, cargar_PlanillasDepositoCheque, inicializar_PlanillasDepositoCheque}, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormCli11);